export const LOAD_PROFILE = "LOAD_PROFILE";
export const REMOVE_PROFILE = "REMOVE_PROFILE";

export const DECRESE_UNREAD_MESSAGES_COUNT = "DECRESE_UNREAD_MESSAGES_COUNT";
export const UPDATE_UNREAD_MESSAGES_COUNT = "UPDATE_UNREAD_MESSAGES_COUNT";
export const ADJUST_UNREAD_MESSAGES_COUNT = "ADJUST_UNREAD_MESSAGES_COUNT";
export const ADJUST_UNREAD_NOTIFICATIONS_COUNT =
  "ADJUST_UNREAD_NOTIFICATIONS_COUNT";
